import axios from 'axios'
import { getHost } from './host'

export interface ReportSchedule {
  report_schedule_id: number;
  schedule_id: number;
  template_id: number;
  customer_id: number;
  requester_user_id: number;
  recipients: number[];
  period: string;
  account_id: number;
  monitor_id: number;
  station_id: number;
  active: number;
  created: string;
  updated: string;
}

export interface CreateReportSchedule {
  station_id: number;
  customer_id: number;
  recipients: any[];
  template_id: number;
}

export interface UpdateReportSchedule {
  report_schedule_id: number;
  station_id?: number;
  customer_id?: number;
  recipients?: any[];
  template_id?: number;
}

export async function getReportSchedule(api_key: string, report_schedule_id: number) {
  const url = `https://${getHost()}/api/report_schedule/${report_schedule_id}`

  const { data } = await axios.get<ReportSchedule>(url, { headers: {'X-API-KEY': api_key, Accept: 'application/json'} });
  return data
}

export async function getReportSchedules(api_key: string, station_id: number) {
  const url = `https://${getHost()}/api/report_schedules`

  const params = {
    station_id: station_id
  }

  const { data } = await axios.get<{ data: ReportSchedule[] }>(
    url, 
    { 
      headers: {'X-API-KEY': api_key, Accept: 'application/json'},
      params: params
    }
  );
  return data.data
}

export async function createReportSchedule(api_key: string, reportSchedule: CreateReportSchedule) {
  var url = `https://${getHost()}/api/report_schedule`

  const bodyFormData = new FormData();

  bodyFormData.append('station_id', reportSchedule.station_id.toString());
  bodyFormData.append('customer_id', reportSchedule.customer_id.toString());
  reportSchedule.recipients.forEach((recipient) => {
      if(recipient.id){
        bodyFormData.append('recipients[]', recipient.id.toString());
      }
      else{
        bodyFormData.append('recipients[]', recipient.toString());
      }
  });
  bodyFormData.append('template_id', reportSchedule.template_id.toString());
  
  const headers = {
    'X-API-KEY': api_key, Accept: 'application/json'
  };

  const { data } = await axios.post<{ data: ReportSchedule }>(url, bodyFormData, { headers: headers });
  
  return data.data
}

export async function updateReportSchedule(api_key: string, reportSchedule: UpdateReportSchedule) {
  var url = `https://${getHost()}/api/report_schedule/${reportSchedule.report_schedule_id}`

  const bodyFormData = new FormData();

  bodyFormData.append('station_id', reportSchedule.station_id.toString());
  bodyFormData.append('customer_id', reportSchedule.customer_id.toString());
  reportSchedule.recipients.forEach((recipient) => {
    if(recipient.id){
      bodyFormData.append('recipients[]', recipient.id.toString());
    }
    else{
      bodyFormData.append('recipients[]', recipient.toString());
    }
  });
  bodyFormData.append('template_id', reportSchedule.template_id.toString());
  
  const headers = {
    'X-API-KEY': api_key, Accept: 'application/json'
  };

  const { data } = await axios.post<{ data: ReportSchedule }>(url, bodyFormData, { headers: headers });
  
  return data.data
}

export async function generateReport(api_key: string, report_schedule_id: number, date: string) {
  var url = `https://${getHost()}/api/report_schedule/${report_schedule_id}/generate`

  const bodyFormData = new FormData();

  bodyFormData.append('report_schedule_id', report_schedule_id.toString());
  bodyFormData.append('date', date.toString());
  
  const headers = {
    'X-API-KEY': api_key, Accept: 'application/json'
  };

  const { data } = await axios.post<{ data: any }>(url, bodyFormData, { headers: headers });
  
  return data.data
}

export async function setActive(api_key: string, report_schedule_id: number, active: number) {
  var url = `https://${getHost()}/api/report_schedule/${report_schedule_id}/${active==1? 'enable' : 'disable'}`

  const headers = {
    'X-API-KEY': api_key, Accept: 'application/json'
  };

  const { data } = await axios.post<{ data: any }>(url, {}, { headers: headers });
  
  return data
}